import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModal } from './confirm-modal.model';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmModalComponent implements AfterViewInit {
    private readonly modal = inject(NgbActiveModal);

    @ViewChild('confirmButton', { static: false }) public confirmButton: ElementRef<HTMLButtonElement>;

    public model: ConfirmModal;

    public ngAfterViewInit(): void {
        setTimeout(() => {
            this.confirmButton?.nativeElement?.focus();
        }, 0);
    }

    public onCancel() {
        this.modal.close(false);
    }

    public onConfirm() {
        this.modal.close(true);
    }
}
